module.exports = __webpack_public_path__ + "static/media/home_inactive.65dd678c.svg";